import React from "react"
import { Box, ButtonBase } from "@mui/material"

const STEPS = ["1 · Plan", "2 · Options", "3 · Result"]

function WizardStepNav({ activeStep, onStepClick }) {
  return (
    <Box data-tour="planner-steps" sx={{ display: "flex", gap: 0.75, mb: 1.25 }}>
      {STEPS.map((label, index) => {
        const isActive = index === activeStep
        return (
          <ButtonBase
            key={label}
            onClick={() => onStepClick(index)}
            sx={{
              flex: 1,
              py: 0.8,
              borderRadius: "16px",
              fontSize: "12px",
              fontWeight: 700,
              fontFamily: "inherit",
              color: isActive ? "#fff" : "#5b7f9c",
              bgcolor: isActive ? "#004f7d" : "#fff",
              border: isActive ? "1px solid #004f7d" : "1px solid #c4cdd5",
              "&:hover": {
                bgcolor: isActive ? "#01426a" : "rgba(0,79,125,0.06)",
              },
            }}
          >
            {label}
          </ButtonBase>
        )
      })}
    </Box>
  )
}

export default React.memo(WizardStepNav)
